import { pontoNoMundo } from './ancoragem'
import { inclinacaoDoPerfilNoPe } from './estatica'
import { parametrosDoObjeto } from './parametros'
import { alturaDoTerrenoEm } from './terreno'
import type { CenaTabletop, ObjetoTabletop } from './tipos'

/** Passo de amostragem do terreno ao longo da escada, em metros. */
const PASSO_M = 0.1
/** Quanto do terreno atrás do pé entra no colisor. */
const ATRAS_DO_PE_M = 3

export interface ChaoSobEscada {
  /** `[distância do pé em direção à parede, altura em relação ao chão do pé]`, crescente em distância. */
  readonly perfilM: ReadonlyArray<readonly [number, number]>
  /** Inclinação do chão no pé, em graus; positiva quando sobe em direção à parede. */
  readonly inclinacaoGraus: number
}

/**
 * O terreno de verdade debaixo de uma escada, no plano vertical que passa pelo
 * pé e pelo topo dela. Alimenta a simulação (colisor fixo) e a fórmula (a
 * inclinação do pé). Devolve `null` para escada na vertical, que não tem lado
 * para onde se inclinar: o teste usa chão plano.
 */
export function chaoSobEscada(cena: CenaTabletop, escada: ObjetoTabletop): ChaoSobEscada | null {
  const pe = pontoNoMundo(escada, 'pe')
  const topo = pontoNoMundo(escada, 'topo')
  const dx = topo[0] - pe[0]
  const dz = topo[2] - pe[2]
  const horizontal = Math.hypot(dx, dz)
  if (horizontal < 1e-3) return null
  const ux = dx / horizontal
  const uz = dz / horizontal
  const altura = (s: number) => alturaDoTerrenoEm(cena, pe[0] + ux * s, pe[2] + uz * s, escada.id)
  const h0 = altura(0)
  const { comprimentoM, anguloGraus } = parametrosDoObjeto(escada)
  const ate = Math.max(1, comprimentoM! * Math.cos(((anguloGraus ?? 60) * Math.PI) / 180))
  const perfilM: Array<readonly [number, number]> = []
  for (let s = -ATRAS_DO_PE_M; s <= ate + 1e-9; s += PASSO_M) {
    const d = Math.round(s * 1000) / 1000
    perfilM.push([d, altura(d) - h0])
  }
  return { perfilM, inclinacaoGraus: inclinacaoDoPerfilNoPe(perfilM) }
}
